import { Component, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { CommonService } from '../services/common/common.service';
import { AuthService } from '../auth/auth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { ThemeService } from '../services/common/theme.service';
import { ThemeConfig } from '../../appconfig';
import { UserService } from '../services/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',

})

export class HeaderComponent implements OnInit, OnDestroy {
  @Output() expanded: boolean = true;
  @Input() hideSubHeader: boolean = false;

  currentUserName: any
  menu!: boolean
  showHeader: boolean = false;
  theme!: ThemeConfig;
  userGroup: any;
  selectedSiteName: any;

  private siteChangeSubscription: Subscription | undefined;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    private authService: AuthService,
    public themeService: ThemeService,
    public userService: UserService) {

  }

  ngOnInit(): void {
    //get current site of user. If he has already selected any particular site then get it from local storage
    // //if not then check if he has access to multiple sites or single. In case of single site access he will have
    // //no option to select site, but if he has access to multiple sites then he will see switch site modal
    // // here the objective to call this method is just to set the current id id in local storage
    this.commonService.getCurrentSiteId();

    // Get selected site name using common service (after setting current site ID)
    this.selectedSiteName = this.commonService.getSelectedSiteName();

    // Subscribe to site changes to update siteName when site is switched
    this.siteChangeSubscription = this.commonService.refreshProject.subscribe((res: any) => {
      if (res) {
        this.selectedSiteName = this.commonService.getSelectedSiteName();
      }
    });

    // Run on initial load
    this.evaluateSubHeaderVisibility();

    // Run on every navigation change
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.evaluateSubHeaderVisibility();
    });
  }

  private getChildRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  get organisationName(): string {
    return this.themeService.getTheme()?.organizationName || '';
  }

  get logoUrl() {
    return this.themeService.getTheme()?.logoUrl || '';
  }

  private evaluateSubHeaderVisibility(): void {
    const currentRoute = this.getChildRoute(this.activatedRoute);
    const data = currentRoute.snapshot.data;
    const currentUrl = this.router.url;
    const hideSubHeaderFromRoute = data['hideHeader'];
    this.hideSubHeader = hideSubHeaderFromRoute || currentUrl.includes('acquisition');
  }

  //for left nav hide and show
  toggleSidebar() {
    this.commonService.isHidden = !this.commonService.isHidden;
  }

  //for left nav hide and show
  showUserProfileModal() {
    this.commonService?.showUserProfileModal.next(true);
  }


  /**
   * Selected Site Switch
   */
  showSwitchSite() {
    this.commonService?.showSiteModal.next(true);
  }



  /**
   * Click Logout Button And All Data Remove localStorage
   */
  logout() {
    localStorage.clear();
    this.authService.logout();
    this.commonService.localStorageSiteId = undefined;
    this.commonService.updateSelectedProjects(null);
  }

  /**
   * Clean up subscriptions on component destroy
   */
  ngOnDestroy(): void {
    if (this.siteChangeSubscription) {
      this.siteChangeSubscription.unsubscribe();
    }
  }
}